import { LocaleValuesFragment } from 'src/generated/operations.ts';

type Value = LocaleValuesFragment | null | undefined;

export const combine = (first: Value, second: Value): Value => {
    if (first && second) {
        return {
            raw: [`${first.raw.join('')} [${second.raw.join('')}]`],
            localized: [`${first.localized.join('')} [${second.localized.join('')}]`],
        };
    }
    return first || second;
};
